import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { CartProvider } from "./context/CartContext";
import { OrderProvider } from "./context/OrderContext";
import LandingPage from "./pages/LandingPage.jsx";
import AboutUs from "./pages/AboutUs.jsx";
import ContactUs from "./pages/ContactUs.jsx";
import LoginPage from "./pages/LoginPage.jsx";
import RegisterPage from "./pages/RegisterPage.jsx";
import RestaurantDashboard from "./pages/RestaurantDashboard.jsx";
import DemoPage from "./pages/DemoPage.jsx";
import MenuPage from "./pages/MenuPage.jsx";
import AdminPage from "./pages/AdminPage.jsx";
import QRCodePage from "./pages/QRCodePage.jsx";
import OrderSuccess from "./pages/OrderSuccess.jsx";
import OrderStatus from "./pages/OrderStatus.jsx";

function App() {
  return (
    <CartProvider>
      <OrderProvider>
        <Router>
          <div className="min-h-screen bg-gray-50">
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/about" element={<AboutUs />} />
              <Route path="/contact" element={<ContactUs />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route
                path="/restaurant-dashboard"
                element={<RestaurantDashboard />}
              />
              <Route path="/demo" element={<DemoPage />} />
              <Route path="/menu/:restaurantId" element={<MenuPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route
                path="/order-success/:orderId"
                element={<OrderSuccess />}
              />
              <Route path="/order-status" element={<OrderStatus />} />
              <Route path="/qr-demo" element={<QRCodePage />} />
            </Routes>
          </div>
        </Router>
      </OrderProvider>
    </CartProvider>
  );
}

export default App;
